/* Built In Imports */


import { useMediaQuery } from "@chakra-ui/react";
import StyleConfig from "@components/UI/Common/StyleConfig";
import CSRTopSliderGroup from "@landing_pages/csr/Banners/CSRTopSliderGroup";
import AwardsAndAccreditation from "@landing_pages/csr/sections/AwardsAndAccreditations";
import ContactUs from "@landing_pages/csr/sections/ContactUs";
import DownloadReport from "@landing_pages/csr/sections/DownloadReport";
import OtherWays from "@landing_pages/csr/sections/OtherWays";
import PastPartners from "@landing_pages/csr/sections/PastPartners";
import Projects from "@landing_pages/csr/sections/Projects";
import SharePage from "@landing_pages/csr/sections/SharePage";
import UnSdc from "@landing_pages/csr/sections/UnSdc";
import WhyPartnerUs from "@landing_pages/csr/sections/WhyPartnerUs";
import YouTubeContent from "@landing_pages/csr/sections/YouTubeContent";
import RegisterStickyButton from "../components/RegisterStickyButton";

/* External Imports */

/* Internal Imports */
/* Components */

/**
 * Renders Render Sadhguru In Aus Sections
 *
 * @param {object} sectionContent - Data
 * @param {string} region - Region of Page
 * @param {string} lang - Language of Page
 * @returns {ReactElement} Render Sadhguru In Aus Sections
 */

const RenderSections = ({
  section,
  region,
  language,
  formElement,
}) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const sectionId = section?.sectionId;
  // console.log("The section in render section is", section)
  if (sectionId === 'banner') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <CSRTopSliderGroup
          sectionContent={section.sectionContent[0]}
          region={region}
          language={language}
          formElement={formElement}
        />
      </StyleConfig>
    );
  }
  else if (sectionId === 'youtube-content') {
    return (
      <YouTubeContent sectionContent={section?.sectionContent} />
    );
  }
  else if (sectionId === 'awards-accreditations') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        style={section?.styleConfig}
      >
        <AwardsAndAccreditation
          section={section}
          region={region}
          language={language}
        />
      </StyleConfig>
    );
  }
  else if (sectionId === 'csr-projects') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        style={section?.styleConfig}
      >
        <Projects
          section={section}
          region={region}
          language={language}
        />
      </StyleConfig>
    );
  }
  else if (sectionId === 'why-partner-with-us') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <WhyPartnerUs
          section={section}
          region={region}
          language={language} />
      </StyleConfig>
    );
  }
  else if (sectionId === 'download-report') {
    return (
      <DownloadReport
        sectionContent={section?.sectionContent}
        region={region}
        language={language} />
    );
  }
  else if (sectionId === 'un-sdc') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <UnSdc
          section={section}
          region={region}
          language={language}
        />
      </StyleConfig>
    );
  }
  else if (sectionId === 'past-partners') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <PastPartners
          section={section}
          region={region}
          language={language}
        />
      </StyleConfig>
    );
  }
  else if (sectionId === 'other-ways-contribute') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        style={section?.styleConfig}
      >
        <OtherWays
          section={section?.sectionContent}
          region={region}
          language={language}
        />
      </StyleConfig>
    );
  }
  else if (sectionId === 'share-this-page') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <SharePage
          section={section?.sectionContent}
          region={region}
          language={language}
        />
      </StyleConfig>
    );
  }
  else if (sectionId === `contact-us`) {
    return <StyleConfig
      id={section.sectionId}
      key={section.sectionId}
      pT="0"
      pB="0"
      mB="0"
      section={section}
    >
      <ContactUs
        section={section?.sectionContent}
        region={region}
        language={language}
      />
    </StyleConfig>
  }
  else if (sectionId === 'partner-withus-sticky-button') {
    // const RegisterStickyButton = dynamic(() =>
    //   import('@landing_pages/csr/components/RegisterStickyButton')
    // );
    return (
      <RegisterStickyButton
        lang={language}
        region={region}
        sectionContent={section.sectionContent}
        formElement={formElement}
      />
    );
  }

};

export default RenderSections;